import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BusinessInfo } from '../../../models/tradie/tradie.model';
import { AlertService } from '../../../services/alert/alert.service';
import { TradieService } from '../../../services/tradie/tradie.service';

@Component({
  selector: 'app-shared-update-business-phone-popup',
  templateUrl: './shared-update-business-phone-popup.component.html',
  styleUrls: ['./shared-update-business-phone-popup.component.scss']
})
export class SharedUpdateBusinessPhonePopupComponent implements OnInit {

  formUpdateContact!: FormGroup;
  currentMobile!: string
  submitted = false;
  isLoading = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SharedUpdateBusinessPhonePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public  businessInfo: BusinessInfo,
    private alertService: AlertService,
    private tradieService: TradieService,
  ) { }

  ngOnInit(): void {
    const afterHNumber = (this.businessInfo.phoneAfterHours ? this.businessInfo.phoneAfterHours : null)

    this.formUpdateContact = this.formBuilder.group({
      businessInfoId: this.businessInfo.id,
      phoneBusinessHours: [this.businessInfo.phoneBusinessHours, [Validators.required, Validators.pattern('^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$')]],
      phoneAfterHours: [afterHNumber, [Validators.pattern('^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$')]],
      email: this.businessInfo.email
    });
  }

    // convenience getter for easy access to form fields
    get f() { return this.formUpdateContact.controls; }

    onSubmit() {
      this.submitted = true;
      if (this.formUpdateContact.invalid) {
        return;
      }
      this.updateBusinessContact()
    }

    // Update user address
    updateBusinessContact() {
      this.isLoading = true;
      this.tradieService.updateBusinessContact(this.formUpdateContact.value).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.alertService.success('Business phone successfully updated');
            const address = response.data;
            this.dialogRef.close(address);
          } else {
            this.alertService.error('Operation failed');
          }
        }, error : err => {
          this.isLoading = false;
          this.alertService.error('Operation failed');
        }
      });
  }
}
